// =====Modules=======
import {CommonModule} from '@angular/common';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import {EnviromentCustomModule} from './environment-custom/environment-custom.module';
import {routing} from '../app.routes';
import {BzTabModule} from '../shared/components/tab/tab.module';
import {BzSwitchModule} from '../shared/components/switch/switch.module';
import {SharedModule} from './../shared/shared.module';
import {FormsModule} from '@angular/forms';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {BzgButtonModule, BzgTabsModule} from 'bz-genome-angular';
// =====Components=====
import {EnvironmentComponent} from './environment.component';
import {EnvironmentPopularComponent} from './environment-popular/environment-popular.component';
import {EnvironmentAdvancedComponent} from './environment-advanced/environment-advanced.component';
// =====Services=======
import {EnvironmentDataService} from './services/environment.data.service';
import {EnvironmentService} from './services/environment.service';
import {UtilsService} from './services/utils.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {EnvironmentAlertComponent} from './environment-save-alert/environment-save-alert.component';
import { SmsConfigurationComponent } from './environment-popular/sms-configuration/sms-configuration.component';
import { DownloadCertificatePasswordModalComponent } from './environment-popular/download-certificate-password-modal/download-certificate-password-modal.component';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './i18n/', '.json');
  }

@NgModule({
    imports: [
        TranslateModule.forRoot({
            loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
            }
          }),
        BsDropdownModule.forRoot(),
        TabsModule.forRoot(),
        AlertModule.forRoot(),
        CommonModule,
        SharedModule,
        EnviromentCustomModule,
        routing,
    ],
    declarations: [
        EnvironmentComponent,
        EnvironmentPopularComponent,
        EnvironmentAdvancedComponent,
        EnvironmentAlertComponent,
        SmsConfigurationComponent,
        DownloadCertificatePasswordModalComponent
    ],
    exports: [
        EnvironmentComponent,
        EnvironmentPopularComponent,
        EnvironmentAdvancedComponent,
        SmsConfigurationComponent,
        DownloadCertificatePasswordModalComponent
    ],
    entryComponents: [
      DownloadCertificatePasswordModalComponent
    ],
    providers: [
        EnvironmentDataService,
        UtilsService,
        EnvironmentService
    ],
    schemas : [CUSTOM_ELEMENTS_SCHEMA]
})
export class EnvironmentModule { }
